import { padding } from '@mui/system';
import React, { useEffect } from 'react';

interface PiramidaProps {
    currentLevel: number;
    pendingLevel: number | null;
    setLevel: React.Dispatch<React.SetStateAction<number>>;
    onStart: () => void;
    pokreniNovuIgru: () => void;
    nextLevelLabel?: string;
}

const Piramida: React.FC<PiramidaProps> = ({ currentLevel, pendingLevel, setLevel, onStart, nextLevelLabel = 'Vrh', pokreniNovuIgru }) => {
    useEffect(() => {
        if (pendingLevel !== null && pendingLevel !== currentLevel) {
            // tek kada se prikaže Piramida, ažuriramo level
            console.log('piramida current pending ', currentLevel, pendingLevel);
            setLevel(pendingLevel);
        }
    }, [pendingLevel, currentLevel, setLevel]);

    const levels = [
        { naziv: 'Dno', vrednost: 1 },
        { naziv: '1. korak', vrednost: 2 },
        { naziv: '2. korak', vrednost: 3 },
        { naziv: '3. korak', vrednost: 4 },
        { naziv: 'Još malo', vrednost: 5 },
    ];

    return (
        <div className="flex flex-col items-center gap-4 w-full py-4">
            <div
                className={`w-[80px] h-[50px] rounded-full border-4 ${currentLevel === 5 ? 'border-gold' : 'border-blue-500'} flex items-center justify-center text-blue-600 font-bold`}
            >
                {currentLevel === 5 ? (
                    <p className="text-white  text-center text-lg font-semibold leading-6 ">{nextLevelLabel}</p>
                ) : currentLevel === 4 ? (
                    <p className="text-white opacity-30 text-center text-lg font-semibold leading-6 ">{nextLevelLabel}</p>
                ) : (
                    <>?</>
                )}
            </div>
            {levels
                .slice()
                .reverse()
                .map((lvl) => (
                    <div
                        key={lvl.vrednost}
                        className={`transition-all delay-200 duration-700 h-[50px] rounded-md flex items-center justify-center ${
                            currentLevel + 1 >= lvl.vrednost
                                ? 'bg-gradient-to-r from-blueLight to-blueDark  scale-105 shadow-lg ring-4 ring-gold'
                                : 'bg-blue-200 scale-100'
                        }`}
                        style={{
                            width: `${340 - lvl.vrednost * 40}px`,
                            maxWidth: '90vw',
                        }}
                    >
                        {currentLevel + 1 >= lvl.vrednost ? (
                            <p className="text-white text-center text-lg font-semibold leading-6 ">{lvl.naziv}</p>
                        ) : currentLevel + 2 === lvl.vrednost ? (
                            <p className="text-white opacity-30 text-center text-lg font-semibold leading-6 ">{lvl.naziv}</p>
                        ) : (
                            <></>
                        )}
                    </div>
                ))}

            {pendingLevel !== 5 ? (
                <button onClick={onStart} className="mt-6 px-6 py-2 bg-schoolBoardLight text-white rounded-lg hover:bg-blue-700 transition">
                    <p className="text-white text-center text-lg font-semibold leading-6 ">Izvuci pitanje</p>
                </button>
            ) : (
                <button onClick={pokreniNovuIgru} className="mt-6 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                    <p className="text-white text-center text-lg font-semibold leading-6 ">Pokreni novu igru</p>
                </button>
            )}
        </div>
    );
};

export default Piramida;
